import { childrenCategoryDerivationType } from 'Rentlio/utils/childrenCategoryDerivationType'
import ChildrenCategoriesTypeEnum from 'Rentlio/utils/childrenCategoriesEnum'

export const getNumberOfChildrenWithPercentageValues = childrenCategories => {
  if (!childrenCategories || childrenCategories.length === 0) {
    return 0
  }

  return childrenCategories.filter(
    category =>
      +category.type === ChildrenCategoriesTypeEnum.CUSTOM &&
      +category.valueType === childrenCategoryDerivationType.PERCENTAGE
  ).length
}
